<template>
  <div class="paper-container" style="display: flex">
    <div class="side">
      <div class="subject">
        <Subject @subClick="handleSub" @requestAll="handleAll"></Subject>
      </div>
      <Include
        :sideList="includeList"
        @includeClick="handleInclude"
        @requestAll="handleAll"
      ></Include>
      <Year
        :sideList="yearList"
        @yearClick="handleYear"
        @requestAll="handleAll2"
      ></Year>
    </div>
    <div class="content">
      <template v-if="itemList.length > 0 || scrollFlag">
        <Item
          v-for="(v, i) in itemList"
          :key="i"
          :curcer="v.articleId"
          :every="v"
          :banTo="true"
          @itemClick="goDetail"
        ></Item>
        <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
      </template>
      <NoData v-if="itemList.length == 0 && !scrollFlag"></NoData>
    </div>
  </div>
</template>

<script>
import NoData from "@/views/PCView/search/components/NoData.vue";
import Include from "@/components/pager/Include.vue";
import Year from "@/components/pager/Year.vue";
import Item from "@/components/pager/Item";
import Subject from "@/components/pager/Subject.vue";
import mixin from "@/mixins";
import Scroll from "@/components/paging/scroll";
export default {
  components: {
    Item,
    Include,
    Year,
    Subject,
    NoData,
    Scroll,
  },
  mixins: [mixin],
  data() {
    return {
      params: {
        articleType: 0,
        name: "论文",
        type: 0,
        pageNo: 1,
        // orderBy: "publishTime",
      },
    };
  },
  created() {
    this.getItemList(this.params);
    this.getIncludeList(); // 收录
    this.getYearList(); // 年份
  },
  methods: {
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "details",
        query: {
          type: e.articleType,
          id: e.articleId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/public.scss";
::v-deep .ivu-tree-empty {
  margin: 30px;
}
.subject {
  height: 559px;
  background-color: #fff;
  margin-bottom: 9px;
  h2 {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    margin: 27px 0px 0 30px;
  }
  .ivu-tree {
    margin: 0 13px;
  }
}
.side {
  width: 300px;
  margin-right: 11px;
}
.content {
  min-height: 1000px;
}
</style>
